import { apiService } from './apiService';

export interface DataVaultDto {
  tenantId?: string;
  name: string;
  type: 'Structured' | 'File Base';
  isActive?: boolean;
  dataSizeBytes?: number;
  description?: string;
}

export interface DataVault {
  id: string;
  tenantId: string;
  name: string;
  type: string;
  isActive?: boolean;
  dataSizeBytes?: number;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
}

export const dataVaultService = {
  getList: () =>
    apiService.get('/api/DataVault/list', {}, 'backend') as Promise<DataVault[]>,

  getById: (id: string) =>
    apiService.get(`/api/DataVault/details/${id}`, {}, 'backend') as Promise<DataVault>,

  create: (dto: DataVaultDto) =>
    apiService.post('/api/DataVault', dto, 'backend'),

  update: (id: string, dto: DataVaultDto) =>
    apiService.put(`/api/DataVault/${id}`, dto, 'backend'),

  delete: (id: string) =>
    apiService.delete(`/api/DataVault/${id}`, 'backend'),
};
